/* HOUSE OF RAHMANI — motion engine. No scroll hijacking; everything degrades to static content. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = false; /* the House wants its motion on every device, even when the phone has 'reduce motion' switched on */
  var desktop = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: true };
  var isRTL = root.getAttribute('dir') === 'rtl';
  var io;
  var parallaxItems = [];
  var spItems = [];
  var spots = [];
  var ticking = false;

  /* ---------- split text (letters for Latin, words for Arabic/RTL so joining stays intact) ---------- */
  function splitText(el) {
    if (el.__rhSplit) return;
    el.__rhSplit = true;
    var mode = el.getAttribute('data-rh-split') === 'words' || isRTL ? 'words' : 'chars';
    if (isRTL) el.setAttribute('data-rh-split', 'words');
    var label = el.textContent.replace(/\s+/g, ' ').trim();
    el.setAttribute('aria-label', label);
    var idx = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = document.createDocumentFragment();
          var parts = mode === 'words' ? child.textContent.split(/(\s+)/) : child.textContent.split(/(\s+)/);
          parts.forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span');
            w.className = 'rh-w';
            w.setAttribute('aria-hidden', 'true');
            if (mode === 'words') {
              var c = document.createElement('span');
              c.className = 'rh-c'; c.style.setProperty('--i', idx++); c.textContent = part;
              w.appendChild(c);
            } else {
              Array.prototype.forEach.call(part, function (ch) {
                var c2 = document.createElement('span');
                c2.className = 'rh-c'; c2.style.setProperty('--i', idx++); c2.textContent = ch;
                w.appendChild(c2);
              });
            }
            frag.appendChild(w);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1 && !child.classList.contains('rh-w')) {
          walk(child);
        }
      });
    }
    walk(el);
  }

  /* ---------- words that light up as you scroll ---------- */
  function scrubSplit(el) {
    if (el.__rhScrub) return;
    el.__rhScrub = true;
    var words = el.textContent.replace(/\s+/g, ' ').trim().split(' ');
    el.setAttribute('aria-label', words.join(' '));
    el.textContent = '';
    words.forEach(function (w, i) {
      var sp = document.createElement('span');
      sp.className = 'rh-sw'; sp.setAttribute('aria-hidden', 'true');
      sp.style.setProperty('--i', i); sp.textContent = w;
      el.appendChild(sp);
      if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
    });
    el.style.setProperty('--n', words.length);
  }

  /* ---------- reveal observer ---------- */
  function observe(scope) {
    scope = scope || document;
    var targets = scope.querySelectorAll('[data-rh-reveal], [data-rh-split], .rh-ed__arch');
    Array.prototype.forEach.call(targets, function (el) {
      if (el.hasAttribute('data-rh-split')) splitText(el);
      if (reduce) { el.classList.add('rh-in'); return; }
      /* clip-path hidden elements never report as intersecting, so watch their parent instead */
      if ((el.getAttribute('data-rh-reveal') === 'mask' || el.getAttribute('data-rh-reveal') === 'write') && el.parentElement) {
        var host = el.parentElement;
        host.__rhMasks = host.__rhMasks || [];
        if (host.__rhMasks.indexOf(el) === -1) host.__rhMasks.push(el);
        io.observe(host);
      } else {
        io.observe(el);
      }
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-rh-scrub]'), scrubSplit);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-rh-sp]'), function (el) { if (spItems.indexOf(el) === -1) spItems.push(el); });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-rh-spot]'), function (el) { if (spots.indexOf(el) === -1) spots.push(el); });
    var px = scope.querySelectorAll('[data-rh-parallax]');
    Array.prototype.forEach.call(px, function (el) {
      if (parallaxItems.indexOf(el) === -1) parallaxItems.push(el);
    });
    onScroll();
  }

  /* ---------- scroll driven values ---------- */
  var lastY = 0;
  var header, hero;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }
  function update() {
    ticking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop;
    var vh = window.innerHeight;
    if (header) {
      var inHero = !!(hero && !reduce && hero.getBoundingClientRect().bottom > window.innerHeight * 0.98);
      header.classList.toggle('is-scrolled', y > 40 && !inHero);
      var open = document.body.classList.contains('rh-menu-open');
      var down = y > lastY + 4, up = y < lastY - 4;
      if (!open && y > 500 && down && !inHero) header.classList.add('is-hidden');
      else if (up || y < 500 || open) header.classList.remove('is-hidden');
      root.style.setProperty('--rh-header-h', header.offsetHeight + 'px');
    }
    lastY = y;
    if (hero && !reduce) { heroProgress(y); }
    spItems.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) return;
      var k = (vh - r.top) / (vh + r.height);
      el.style.setProperty('--sp', Math.min(1, Math.max(0, k)).toFixed(4));
    });
    if (!reduce && desktop.matches) {
      parallaxItems.forEach(function (el) {
        var r = el.parentElement ? el.parentElement.getBoundingClientRect() : el.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) return;
        var speed = parseFloat(el.getAttribute('data-rh-parallax')) || 0.1;
        var center = r.top + r.height / 2 - vh / 2;
        el.style.translate = '0 ' + (-center * speed).toFixed(1) + 'px';
      });
    } else {
      parallaxItems.forEach(function (el) { el.style.translate = ''; });
    }
  }

  /* ---------- hero: --p = max(intro tween, scroll progress through the pinned hero) ---------- */
  var intro = reduce ? 1 : 0;
  function heroProgress(y) {
    var span = hero.offsetHeight - window.innerHeight;
    var top = hero.getBoundingClientRect().top + y;
    var sp = span > 0 ? Math.min(1, Math.max(0, (y - top) / span)) : 1;
    var p = Math.max(intro, sp);
    hero.style.setProperty('--p', p.toFixed(4));
    var isOpen = p > 0.86;
    hero.classList.toggle('is-open', isOpen);
    window.__rhP = p;
    document.body.classList.toggle('rh-hdr-quiet', p > 0.03 && p < 0.985);
  }
  function playIntro() {
    if (!hero || reduce) return;
    var t0 = null, dur = 2600, target = 0;
    function step(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      intro = target * (1 - Math.pow(1 - k, 3));
      heroProgress(window.pageYOffset || 0);
      if (k < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- header tone + menu ---------- */
  function initHeader() {
    header = document.querySelector('.rh-header');
    if (!header) return;
    var first = document.querySelector('main [data-header-tone]');
    var mainEl = document.querySelector('main');
    var firstSection = mainEl && mainEl.firstElementChild;
    var hasHero = !!(first && firstSection && firstSection.contains(first));
    document.body.classList.toggle('rh-hero-top', !!hasHero);
    document.body.classList.toggle('rh-header-dark', !!(hasHero && first.getAttribute('data-header-tone') === 'dark'));
    if (!hasHero) header.classList.remove('is-hidden');

    var menu = document.getElementById('RhMenu');
    var btn = document.querySelector('.rh-burger');
    if (!menu || !btn) return;
    var closeBtn = menu.querySelector('.rh-menu__close');
    function setOpen(open) {
      menu.classList.toggle('is-open', open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('rh-menu-open', open);
      if (open) { closeBtn.focus(); } else { btn.focus({ preventScroll: true }); }
    }
    btn.addEventListener('click', function () { setOpen(true); });
    closeBtn.addEventListener('click', function () { setOpen(false); });
    menu.addEventListener('click', function (e) { if (e.target.closest('a')) setOpen(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) setOpen(false);
    });
    window.addEventListener('resize', function () { if (window.innerWidth > 1100 && menu.classList.contains('is-open')) setOpen(false); });
  }

  /* ---------- soft light that follows the pointer (desktop) ---------- */
  var ptr = { x: .5, y: .44, tx: .5, ty: .44, on: false };
  function initPointer() {
    if (reduce || !window.matchMedia || !window.matchMedia('(hover: hover)').matches || ptr.bound) return;
    ptr.bound = true;
    window.addEventListener('pointermove', function (e) {
      ptr.tx = e.clientX / window.innerWidth; ptr.ty = e.clientY / window.innerHeight;
      if (!ptr.on) { ptr.on = true; requestAnimationFrame(ptrStep); }
    }, { passive: true });
  }
  function ptrStep() {
    ptr.x += (ptr.tx - ptr.x) * 0.07; ptr.y += (ptr.ty - ptr.y) * 0.07;
    var mx = (ptr.x * 100).toFixed(2) + '%', my = (ptr.y * 100).toFixed(2) + '%';
    if (hero) { hero.style.setProperty('--mx', mx); hero.style.setProperty('--my', my); hero.style.setProperty('--px', ((ptr.x - 0.5) * 2).toFixed(3)); hero.style.setProperty('--py', ((ptr.y - 0.5) * 2).toFixed(3)); }
    spots.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      el.style.setProperty('--mx', (((ptr.x * window.innerWidth) / r.width) * 100).toFixed(2) + '%');
      el.style.setProperty('--my', ((((ptr.y * window.innerHeight) - r.top) / r.height) * 100).toFixed(2) + '%');
    });
    if (Math.abs(ptr.tx - ptr.x) + Math.abs(ptr.ty - ptr.y) > 0.0008) requestAnimationFrame(ptrStep); else ptr.on = false;
  }

  /* ---------- 3D hero scene (loaded only when WebGL is available and motion is welcome) ---------- */
  function loadScript(src, cb) {
    var el = document.createElement('script'); el.src = src; el.async = true; el.onload = cb; el.onerror = function () {};
    document.head.appendChild(el);
  }
  function startScene(canvas) {
    try {
      var ok = window.RahmaniScene && window.RahmaniScene.init(canvas, canvas.parentElement, { reduce: reduce });
      if (ok) hero.classList.add('has-gl');
    } catch (e) { /* the CSS velvet stays as the fallback */ }
  }
  function initGL() {
    var canvas = document.querySelector('.rh-hero__gl');
    if (!canvas || canvas.__rhGL) return;
    canvas.__rhGL = true;
    var test = document.createElement('canvas');
    if (!(window.WebGLRenderingContext && (test.getContext('webgl') || test.getContext('experimental-webgl')))) return;
    if (window.THREE && window.RahmaniScene) return startScene(canvas);
    var go = function () { loadScript(canvas.getAttribute('data-scene'), function () { startScene(canvas); }); };
    if (window.THREE) go(); else loadScript(canvas.getAttribute('data-three'), go);
  }

  /* ---------- init ---------- */

  function initFilters() {
    document.querySelectorAll('[data-rh-filters]').forEach(function (bar) {
      var scope = bar.parentNode;
      bar.addEventListener('click', function (e) {
        var b = e.target.closest('[data-filter]'); if (!b) return;
        var f = b.getAttribute('data-filter');
        bar.querySelectorAll('.rh-filter').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        scope.querySelectorAll('.rh-card').forEach(function (c) {
          var tags = (c.getAttribute('data-tags') || '').split(',');
          var show = f === 'all' || tags.indexOf(f) > -1;
          c.classList.toggle('rh-hide', !show);
          if (show) c.classList.add('rh-in');
        });
      });
    });
  }

  function initPopup() {
    var d = document.querySelector('[data-rh-pop]');
    if (!d || typeof d.showModal !== 'function') return;
    var days = parseInt(d.getAttribute('data-days'), 10) || 14, delay = (parseInt(d.getAttribute('data-delay'), 10) || 20) * 1000;
    var KEY = 'rh-pop', done = false, posted = !!d.querySelector('.rh-form__ok');
    function seen() { try { var t = parseInt(localStorage.getItem(KEY), 10); return t && Date.now() - t < days * 864e5; } catch (e) { return false; } }
    function mark() { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} }
    function open() { if (done || d.open) return; done = true; try { d.showModal(); } catch (e) {} mark(); }
    function close() { d.classList.add('is-out'); setTimeout(function () { d.close(); d.classList.remove('is-out'); }, 350); }
    d.querySelector('[data-rh-pop-close]').addEventListener('click', close);
    d.addEventListener('click', function (e) { if (e.target === d) close(); });
    if (posted) { open(); return; }
    if (seen()) return;
    setTimeout(function () { if ((window.__rhP || 1) > .9) open(); else { var iv = setInterval(function () { if ((window.__rhP || 1) > .9 || done) { clearInterval(iv); open(); } }, 1500); } }, delay);
    document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 4 && (window.__rhP || 1) > .9) open(); });
  }

  function init() {
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            en.target.classList.add('rh-in');
            if (en.target.__rhMasks) en.target.__rhMasks.forEach(function (m) { m.classList.add('rh-in'); });
            io.unobserve(en.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    } else {
      io = { observe: function (el) { el.classList.add('rh-in'); }, unobserve: function () {} };
    }
    hero = document.querySelector('.rhz');
    initHeader();
    observe(document);
    playIntro();
    initGL();
    initPointer();
    initFilters();
    initPopup();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when sections are added/changed */
  document.addEventListener('shopify:section:load', function (e) {
    if (!io) return;
    hero = document.querySelector('.rhz');
    initHeader();
    observe(e.target);
  });
})();
